<ng-select
  class="ng-select-sm"
  [items]="valueListItems"
  bindLabel="vliName"
  bindValue="vliName"
  [formControl]="control"
  [placeholder]="placeholder"
  (blur)="onBlur.emit()"
  (change)="onChange.emit($event)"
  [addTag]="allowAddingItem ? addTag : false"
  [loading]="isLoading">
</ng-select>